import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Filter } from "../../models/filter.model";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { UserMapDataProvider } from "../../data-provider/user-map.dp";
import { SearchUtils } from "../../helper/search.helper";
import { PermissionCheck } from "../../shared/permission";

let UserMapComponent = {
    selector: "vcUserMap",
    templateUrl: "/angular/components/user-map/user-map.component.html",
    controller: class UserMap {
        private $scope: any;
        private dataProvider: UserMapDataProvider;
        private userDataProvider: UserDataProvider;
        private searchUtils: SearchUtils;
        private $location: any;
        private $q: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private __env: any;
        private campaignDataProvider: CampaignDataProvider;
        private modelsUtils: any;

        public activeCampaign: any;
        public selectedUser: User;
        public filter: Filter;
        public search: any;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $location: any,
            $q: any,
            __env: any,
            UserMapDataProvider: UserMapDataProvider,
            UserDataProvider: UserDataProvider,
            SearchUtils: SearchUtils,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider,
            ModelsUtils: any,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.dataProvider = UserMapDataProvider;
            this.filter = new Filter();
            this.userDataProvider = UserDataProvider;
            this.searchUtils = SearchUtils;
            this.$location = $location;
            this.$q = $q;
            this.toast = ToastUtils;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.campaignDataProvider = CampaignDataProvider;
            this.modelsUtils = ModelsUtils;
            this.selectedUser = this.modelsUtils.user();
            this.search = this.$location.search();
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.permissionProvider = PermissionCheck;
        }

        $onInit(): void {
            if (this.search.filter) {
                this.filter.setData(JSON.parse(this.search.filter));
                this.searchUtils.searchText =
                    this.filter.search.values || this.filter.search;
            }

            if (!this.filter.search || typeof this.filter.search === "string") {
                this.filter.search = {
                    values: this.filter.search || "",
                    checked: true,
                };
            }

            this.searchUtils.setSearchBar(
                "Search Users",
                (searchText: string) => {
                    this.filter.search.values = searchText || "";
                    return this.$q.resolve([]); //Not using the results for the search dropdown so return empty.
                },
                null,
                true
            );
        }

        updateUser(user: User, event: Object): void {
            user.permissionid = user.permission.permissionid;
            this.dialog
                .show({
                    component: "vc-update-user-dialog",
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    locals: {
                        user: user,
                    },
                })
                .then((data: Object) => user.setData(data));
        }

        deleteUser(user: User, $event: Object): void {
            this.dialog
                .delete({
                    targetEvent: $event,
                    locals: {
                        title: "Delete User?",
                        bodyText: "They will be permanently deleted",
                    },
                })
                .then(() => {
                    this.userDataProvider.removeUser(user).then(
                        () => {
                            this.toast.success("User Deleted");
                            this.dataProvider.reset();
                            this.dataProvider.getMapMarkers();
                            this.selectedUser.uid = null;
                        },
                        () => this.toast.error()
                    );
                });
        }
    },
};

angular
    .module("userMap")
    .component(UserMapComponent.selector, UserMapComponent);
